module.exports = __webpack_public_path__ + "img/snb_gdco.dc4c639f.svg";